export default {
  link: process.env.VUE_APP_COPYRIGHTS_LINK || 'https://cultart.biz/cultart',
}
